import type { QueryClient } from '@tanstack/react-query';

const WMS_INTEGRATION_KEYS = [
  'eagle_labs',
  'ship_offers',
  'tb3',
  'jetpack',
] as const;

/** Prefixo do queryKey do MultiComboBox com queryKey="products". */
export const WMS_PRODUCT_OPTIONS_QUERY_KEY = 'multi-combo-options-products';

export function isWmsIntegration(integrationKey: string): boolean {
  return (WMS_INTEGRATION_KEYS as readonly string[]).includes(integrationKey);
}

/**
 * Categoria de produtos para seleção de produtos em integrações WMS.
 * Retorna undefined para outras integrações (sem filtro — todos os tipos).
 */
export function productCategoryTypesForIntegration(
  integrationKey: string,
): string[] | undefined {
  if (isWmsIntegration(integrationKey)) {
    return ['physical', 'pharmaceutical'];
  }
  return undefined;
}

/**
 * Invalida o cache de opções de produtos do MultiComboBox após mutações WMS,
 * para que exclusão mútua entre parceiros de fulfillment reflita na UI.
 */
export function invalidateWmsProductOptions(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    queryKey: [WMS_PRODUCT_OPTIONS_QUERY_KEY],
  });
}
